import { assignBudgetsStyles } from "@insite/content-library/Widgets/Budget/AssignBudgets";
import { headerStyles } from "@insite/content-library/Widgets/Budget/BudgetManagementHeader";
import { configureBudgetStyles } from "@insite/content-library/Widgets/Budget/ConfigureBudget";
import {costCodesStyles} from "@insite/content-library/Widgets/Budget/CostCodes"
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";


headerStyles.costCodesButton = {
    mergeCss:true,
    variant: "secondary",
    css: css`
        white-space: nowrap;
    `,
}

headerStyles.assignBudgetsButton = {
    mergeCss:true,
    variant: "secondary",
    css: css`
        white-space: nowrap;
        margin-left: 10px;
    `,
}

headerStyles.configureBudgetsButton = {
    mergeCss:true,
    css: css`
        white-space: nowrap;
        margin-left: 10px;
    `,
}

headerStyles.overflowMenu = {
    cssOverrides: {
        wrapper: css`
            margin-left: 20px;
            button {
                min-width: 100%;
                &:hover {
                    border: none !important;
                    background: none !important;
                }
                &:focus {
                    outline: none !important;
                }
            }
        `,
    },
}

headerStyles.titleGridItem = {
    width: [9, 9, 7, 5, 6],
}

headerStyles.buttonsGridItem = {
    width: [3, 3, 5, 7, 6],
    css: css`
        display: flex;
        justify-content: flex-end;
    `,
}

configureBudgetStyles.cancelButton= {
    variant: "secondary",
}

configureBudgetStyles.saveButton = {
    mergeCss:true,
    css: css`
        margin-left: 10px;
    `,
}

assignBudgetsStyles.cancelButton = {
    mergeCss:true,
    variant: "secondary",
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        width: 50%;
                    `,
                    null,
                    null,
                    null,
                ],
                "max",
            )}
    `,
}

assignBudgetsStyles.saveButton = {
    mergeCss:true,
    css: css`
        margin-left: 10px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    width: 50%;
                `,
                css`
                    width: 50%;
                `,
                null,
                null,
                null,
            ])}
    `,
}

costCodesStyles.cancelButton = {
    variant: "secondary",
}

costCodesStyles.saveButton = {
    mergeCss:true,
    css: css`
        margin-left: 10px;
    `,
}

costCodesStyles.addCostCodeButton = {
    mergeCss:true,
    css: css`
        display: flex;
    `,
    variant: "secondary",
}